import type { IElPosition } from './models';

// window.visualViewport - экспериментальная фича, есть не во всех браузерах. без нее глюки в хроме
/* istanbul ignore next */
export const getViewportHeight = () =>
    window.visualViewport ? window.visualViewport.height : window.innerHeight;

export const detectPositionInViewport = (top: number, bottom: number): IElPosition => {
    const viewportHeight = getViewportHeight();
    // определим положения верхней границы блока относительно вьюпорта
    const isElTopBelowViewport = top - viewportHeight > 0;
    const isElTopAboveViewport = top < 0;
    const isElTopInViewport = !isElTopBelowViewport && !isElTopAboveViewport;
    // определим положения нижней границы блока относительно вьюпорта
    const isElBottomBelowViewport = bottom - viewportHeight > 0;
    const isElBottomAboveViewport = bottom < 0;
    const isElBottomInViewport = !isElBottomBelowViewport && !isElBottomAboveViewport;

    // элемент внутри вьюпорта и меньше него
    const isElEntireInViewport = isElTopInViewport && isElBottomInViewport;
    // кусок элемента внутри вьюпорта или полностью
    const isElPartlyInViewport =
        (isElTopInViewport && isElBottomBelowViewport) ||
        (isElTopAboveViewport && isElBottomInViewport) ||
        isElEntireInViewport;
    // элемент больше вьюпорта и занимает весь вьюпорт
    const isViewportInsideEl = isElTopAboveViewport && isElBottomBelowViewport;

    // верхняя граница viewport находится внутри элемента target
    const isViewportTopInsideEl = isElTopAboveViewport && !isElBottomAboveViewport;
    // нижняя граница viewport находится внутри элемента target
    const isViewportBottomInsideEl = isElBottomBelowViewport && isElPartlyInViewport;
    // const isViewportBottomInsideEl = isElBottomBelowViewport;

    return {
        isElEntireInViewport,
        isElPartlyInViewport,
        isViewportInsideEl,
        isViewportTopInsideEl,
        isViewportBottomInsideEl,
    };
};
